import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUndoStore = defineStore('undoStore', () => {
  const hasUndo = ref(false);
  const functions: UndoFunction[] = [];
  const title = ref<string>('');
  const description = ref<string>('');

  function add(options: AddUndoOptions) {
    title.value = options.title;
    description.value = options.description;
    functions.length = 0;
    functions.push(options.function);
    hasUndo.value = true;

    if (options.extraFunctions) {
      for (const func of options.extraFunctions) {
        functions.push(func);
      }
    }
  }

  function addExtraUndoFunction(func: UndoFunction) {
    functions.push(func);
  }

  function resetUndo() {
    hasUndo.value = false;
    functions.length = 0;
    title.value = '';
    description.value = '';
  }

  async function executeUndo() {
    for (const func of functions) {
      await func();
    }
    resetUndo();
  }

  return {
    add,
    addExtraUndoFunction,
    executeUndo,
    title,
    description,
    hasUndo
  };
});

type UndoFunction = () => Promise<void>;

export interface AddUndoOptions {
  title: string;
  description: string;
  function: UndoFunction;
  extraFunctions?: UndoFunction[];
}
